const BLOCKED_TAGS = new Set([
  "script",
  "style",
  "iframe",
  "object",
  "embed",
  "link",
  "meta"
]);

const URL_ATTRS = new Set(["href", "src", "xlink:href"]);
const ALLOWED_PROTOCOLS = ["http:", "https:", "mailto:", "tel:"];

const isSafeUrl = (value) => {
  if (!value) return false;

  const trimmed = String(value).trim();
  if (!trimmed) return false;
  if (trimmed.startsWith("#") || trimmed.startsWith("/")) return true;

  try {
    const parsed = new URL(trimmed, window.location.origin);
    return ALLOWED_PROTOCOLS.includes(parsed.protocol);
  } catch (error) {
    return false;
  }
};

const sanitizeElement = (element) => {
  const tagName = element.tagName ? element.tagName.toLowerCase() : "";
  if (BLOCKED_TAGS.has(tagName)) {
    element.remove();
    return;
  }

  Array.from(element.attributes).forEach((attribute) => {
    const name = attribute.name.toLowerCase();
    if (name.startsWith("on")) {
      element.removeAttribute(attribute.name);
      return;
    }

    if (URL_ATTRS.has(name) && !isSafeUrl(attribute.value)) {
      element.removeAttribute(attribute.name);
      return;
    }

    if (name === "target") {
      element.setAttribute("target", "_blank");
      element.setAttribute("rel", "noopener noreferrer");
    }
  });

  Array.from(element.children).forEach((child) => sanitizeElement(child));
};

export const sanitizeRichText = (html) => {
  if (!html) return "";
  if (typeof window === "undefined" || typeof DOMParser === "undefined") {
    return String(html);
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(String(html), "text/html");
  Array.from(doc.body.children).forEach((child) => sanitizeElement(child));
  return doc.body.innerHTML;
};
